import { DataTable } from '@/components/ui/DataTable';
import { Badge } from '@/components/ui/Badge';
import type { AuditLogEntry } from '@/types/admin.types';
import { formatDateTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';

const columnHelper = createColumnHelper<AuditLogEntry>();

const columns = [
  columnHelper.accessor('createdAt', {
    header: 'Date',
    cell: (info) => <span className="text-xs text-neutral-500">{formatDateTime(info.getValue())}</span>,
  }),
  columnHelper.accessor('adminEmail', {
    header: 'Admin',
    cell: (info) => <span className="text-sm text-neutral-700 dark:text-neutral-300">{info.getValue()}</span>,
  }),
  columnHelper.accessor('action', {
    header: 'Action',
    cell: (info) => <Badge variant="info">{info.getValue()}</Badge>,
  }),
  columnHelper.accessor('targetType', {
    header: 'Cible',
    cell: (info) => <span className="text-xs text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('ipAddress', {
    header: 'IP',
    cell: (info) => <span className="text-xs text-neutral-500 font-mono">{info.getValue()}</span>,
  }),
];

interface AuditLogTableProps {
  data: AuditLogEntry[];
  loading?: boolean;
}

export function AuditLogTable({ data, loading }: AuditLogTableProps) {
  return <DataTable columns={columns} data={data} loading={loading} emptyMessage="Aucune entree dans le journal" pageSize={50} />;
}
